module.exports = __webpack_public_path__ + "static/media/yt.38abb75f.svg";